import { css } from 'styled-components';
import {
  ScrollbarForeground,
  ScrollBarBackground,
  lightBlue,
  pastelBlue,
  white,
} from '../../../../../../styling/theme';

export const mozillaScrollStyles = (isFullscreen) => css`
  overflow-y: auto;
  overflow-x: ${isFullscreen ? 'overlay' : 'hidden'};
  scrollbar-color: ${ScrollbarForeground} ${ScrollBarBackground}; /* thumb and track color */
  scrollbar-width: thin;
`;

/**
 * * Exporting without the external additional css wrapper would create stylin typescript error
 */
export const mozillaScrollBar = (isFullscreen) => css`
  ${() => css`
    @-moz-document url-prefix() {
      ${mozillaScrollStyles(isFullscreen)}
    }
  `}
`;

export default (params) => {
  const { width, height, isFullscreen, trackColor } = params;

  return css`
    overflow-x: ${isFullscreen ? 'overlay' : 'hidden'};
    /* width */
    &::-webkit-scrollbar {
      width: ${width};
      height: ${height};
    }
    /* Track */
    &::-webkit-scrollbar-track {
      padding-right: 8px;
      background: ${trackColor || white};
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background-color: ${pastelBlue};
      border-radius: 4px;
    }
    /* Handle on hover */
    &:hover {
      &::-webkit-scrollbar-thumb {
        background: ${() => lightBlue};
      }
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: ${() => lightBlue};
    }

    ${mozillaScrollBar(isFullscreen)}
  `;
};
